import {
  LIST_NAME_METRICS,
  LIST_NAME_METRICS_RESET,
  InitialState,
  ListNameMetricActions,
  ListMetricsState,
} from './types'

const ListNameMetricsReducer = (
  state: ListMetricsState = InitialState,
  action: ListNameMetricActions
): ListMetricsState => {
  switch (action.type) {
    case LIST_NAME_METRICS: {
      return {
        ...state,
        list_name: action.payload,
      }
    }
    case LIST_NAME_METRICS_RESET: {
      return {
        ...state,
        list_name: null,
      }
    }
    default:
      return state
  }
}

export default ListNameMetricsReducer
